import EPublicRoutes from "@core-types/routes.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Avatar, Box, Text } from "@mantine/core";
import { Link } from "react-router";
import FadeUp from "../../shared/components/FadeUp";
import type IChampion from "../../shared/models/IChampion.model";

interface ISkinCardProps {
  champion: IChampion;
}

const ChampionAvatarCard: React.FC<ISkinCardProps> = ({ champion }) => {
  const { t } = useAppTranslation("components.championAvatarCard");
  const { locationUrlBuilder } = useAppLanguage();

  const url = locationUrlBuilder(EPublicRoutes.SMURFS_SKIN, champion.slug);

  return (
    <FadeUp>
      <Box
        className={
          "gradient-skin-card hover-scale flex h-[154px] cursor-pointer select-none flex-col items-center justify-center rounded-[23px] no-underline shadow-2xl"
        }
        component={Link}
        to={url}
      >
        <Avatar
          alt={t("alt", { name: champion.name })}
          imageProps={{
            title: t("alt", { name: champion.name }),
          }}
          size={81}
          src={champion.thumbnail}
          title={t("alt", { name: champion.name })}
        />
        <Text className="font-bold font-inter text-primary-white">
          {champion.name}
        </Text>
      </Box>
    </FadeUp>
  );
};

export default ChampionAvatarCard;
